'use strict';

import {element_exists, redesignDataTablesHeader} from "./functions";
import {
    addFormControlSelect2,
    addSelectedCompanyHandler,
    fnToastrFormError,
    getSelectedCompany,
    listFormError,
    printResponse,
    setSelectionMultiSelect
} from "./jquery-functions-library";

export var fnDatatable_users = function () {

    var tableNameUsers = '#datatable-users';

    if (!element_exists(tableNameUsers) || $.fn.dataTable.isDataTable(tableNameUsers)) {
        return false;
    }

    // var formCreateUser = $('#form-create-user');
    var tableUsers = $(tableNameUsers);
    // var companySelect = formUserEdit.find('select[name="company_ids[]"]');
    // var companies;
    // var tableData;

    /*Set a request token in compliance with Laravel. Put a token in the header in rights-settings.*/
    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

    let $filterUserStatus = $('#filter_user_status');
    $filterUserStatus.select2();
    addFormControlSelect2();


    tableUsers.css('width', "100%");
    tableUsers.DataTable({

        autoWidth: true,
        language: allLangFiles.datatables,
        //url for the update function
        ajax: '/update-users-table/' + getSelectedCompany() + '?grouping=' + $filterUserStatus.val(),
        rowId: 'id',
        scrollX: true,
        /*Rules for filling the columns*/
        columnDefs: [
            {visible: false, targets: 0}
        ],
        columns: [
            {data: 'companyIds'},
            {data: 'name'},
            {data: 'companies_display'},
            {data: 'roles_display_name'},
            {
                render: function (data, type, row) {
                    var rolesString = '';
                    for (var i = 0; i < row.roles.length; i++) rolesString += row.roles[i].description + ', ';
                    return rolesString.substring(0, rolesString.length - 2);
                }
            },
            {data: 'has_accepted_invite'},
            {data: 'actions'},
        ]
    });

    var table = tableUsers.DataTable();

    $filterUserStatus.on('change', function (e) {
        tableUsers.DataTable().clear();
        tableUsers.DataTable().ajax.url('/update-users-table/' + getSelectedCompany() + '?grouping=' + $filterUserStatus.val());
        tableUsers.DataTable().ajax.reload(null, false);
    });
    addSelectedCompanyHandler(function (e) {
        // console.log(tableUsers);
        // console.log(tableUsers.DataTable());
        tableUsers.DataTable().clear();
        tableUsers.DataTable().ajax.url('/update-users-table/' + getSelectedCompany() + '?grouping=' + $filterUserStatus.val());
        tableUsers.DataTable().ajax.reload(null, false);
    });

    const {$filterButtons} = redesignDataTablesHeader(tableNameUsers, true, null, false);

    $filterButtons.prepend($('#create-user-btn'));

    var lang = allLangFiles.users.js;

    $(tableNameUsers + ' tbody').off('click');

    $(tableNameUsers + ' tbody').on('click', '.btn-reset-pw', function () {

        var tableData = table.row($(this).parents('tr')).data();

        $.confirm({
            title: lang.reset.title,
            content: lang.reset.content1 + tableData.name + lang.reset.content2,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        $.ajax({
                            method: 'GET',
                            url: '/users/reset-password/' + tableData.id,
                            success: function (response) {

                                response.success !== undefined ? toastr.success(response.success) : toastr.error(response.error);
                            },
                            error: fnToastrFormError,
                        });
                    },
                    text: lang.yes
                },
                Nej: {
                    text: lang.no
                }
            }
        });
    });

    $(tableNameUsers + ' tbody').off('click', '.btn-edit').on('click', '.btn-edit', function () {

        var tableData = table.row($(this).parents('tr')).data();

        $.ajax({
            method: 'GET',
            url: '/users/edit/' + tableData.id,
            success: function (response) {
                $('.dynamic-modal-container').append(response);

                var formUserEdit = $('#form-user-edit');
                var modalUpdateUser = $('#modal-lg-primary');
                var companySelect = formUserEdit.find('select[name="company_ids[]"]');
                var contactPersonSelect = $('select[name="contact_persons[]"]');

                modalUpdateUser.modal('show');

                setSelectionMultiSelect(tableData.companies, companySelect);
                for (var i = 0; i < tableData.companies.length; i++) {
                    var company = tableData.companies[i];
                    $.each(tableData.roles, function (index, value) {
                        var id = value.id;
                        if (value.pivot.company_id == company.id) {
                            $('#role_ids').find('option[value="' + company.id + '_' + id + '"]').prop('selected', true);
                        }
                    });
                }
                companySelect.select2({
                    width: '100%', height: '100%', dropdownParent: modalUpdateUser
                }).addClass('form-control');

                addMultiSelectRoles($('#role_ids'), allLangFiles.roles.select.roles, 3, false);
                addChangeHandler(companySelect, formUserEdit);
                syncSelectedCompanyWithRoles(companySelect, formUserEdit);
                syncSelectedCompanyWithContacts(companySelect);
                contactPersonSelect.select2({
                    width: '100%', height: '100%'
                }).addClass('form-control');
                addFormControlSelect2();

                formUserEdit.off('submit').on('submit', function (e) {
                    e.preventDefault();

                    var url = this.action;

                    //Reenable companies temporarily so they are serialized
                    companySelect.removeAttr('disabled');
                    var data = $(this).serialize();
                    companySelect.attr('disabled','disabled');

                    $.ajax({
                        method: 'POST',
                        url: url,
                        data: data,
                        success: function (response) {
                            console.log(response);
                            tableUsers.DataTable().ajax.reload(null, false);
                            modalUpdateUser.modal('hide');

                            printResponse(response);
                        },
                        error: function (data) {
                            listFormError(data, formUserEdit.find('.error-list'))
                        },
                    });
                });
                modalUpdateUser.off('hidden.bs.modal').on('hidden.bs.modal', function () {
                    modalUpdateUser.remove();
                });
                /*Delete method*/
                $('#modal-btn-delete-user').off('click').on('click', function () {

                    var token = $(this).data('token');
                    var url = $(this).data('href');

                    $.confirm({
                        title: lang.delete.title,
                        content: lang.delete.content,
                        theme: 'supervan',
                        columnClass: 'col-md-12',
                        backgroundDismiss: true,
                        buttons: {
                            Ja: {
                                action: function () {

                                    $.ajax({
                                        method: 'DELETE',
                                        data: {
                                            _token: token
                                        },
                                        url: url,
                                        success: function (response) {
                                            console.log(response);

                                            printResponse(response);

                                            tableUsers.DataTable().ajax.reload(null, false);
                                            modalUpdateUser.modal('hide');
                                        },
                                        error: fnToastrFormError,
                                    });
                                },
                                text: lang.yes
                            },
                            Nej: {
                                text: lang.no
                            }
                        }
                    });
                });

                $('#modal-btn-deactivate-user').off('click').on('click', function () {

                    var token = $(this).data('token');
                    var url = $(this).data('href');

                    $.confirm({
                        title: allLangFiles.users.deactivate.title,
                        content: allLangFiles.users.deactivate.content,
                        theme: 'supervan',
                        columnClass: 'col-md-12',
                        backgroundDismiss: true,
                        buttons: {
                            Ja: {
                                action: function () {

                                    $.ajax({
                                        method: 'POST',
                                        data: {
                                            _token: token
                                        },
                                        url: url,
                                        success: function (response) {
                                            console.log(response);

                                            printResponse(response);

                                            tableUsers.DataTable().ajax.reload(null, false);
                                            modalUpdateUser.modal('hide');
                                        },
                                        error: fnToastrFormError,
                                    });
                                },
                                text: allLangFiles.users.deactivate.yes
                            },
                            Nej: {
                                text: allLangFiles.users.deactivate.no
                            }
                        }
                    });
                });

                $('#modal-btn-activate-user').off('click').on('click', function () {

                    var token = $(this).data('token');
                    var url = $(this).data('href');

                    $.confirm({
                        title: allLangFiles.users.activate.title,
                        content: allLangFiles.users.activate.content,
                        theme: 'supervan',
                        columnClass: 'col-md-12',
                        backgroundDismiss: true,
                        buttons: {
                            Ja: {
                                action: function () {

                                    $.ajax({
                                        method: 'POST',
                                        data: {
                                            _token: token
                                        },
                                        url: url,
                                        success: function (response) {
                                            printResponse(response);

                                            tableUsers.DataTable().ajax.reload(null, false);
                                            modalUpdateUser.modal('hide');
                                        },
                                        error: fnToastrFormError,
                                    });
                                },
                                text: allLangFiles.users.activate.yes
                            },
                            Nej: {
                                text: allLangFiles.users.activate.no
                            }
                        }
                    });
                });
            }
        });
    });

    $('#create-user-btn').off('click').on('click', function (e) {

        $.ajax({
            method: 'GET',
            url: '/users/create',
            success: function (response) {
                $('.dynamic-modal-container').append(response);

                var modalCreateUser = $('#modal-create-user');
                var formCreateUser = $('#form-create-user');
                var companySelect = formCreateUser.find('select[name="company_ids[]"]');

                modalCreateUser.modal('show');

                companySelect.select2({
                    width: '100%', height: '100%', dropdownParent: modalCreateUser
                }).addClass('form-control');
                addFormControlSelect2();
                addMultiSelectRoles($('#role_ids'), allLangFiles.roles.select.roles, 3, false);
                addChangeHandler(companySelect, formCreateUser);
                syncSelectedCompanyWithRoles(companySelect, formCreateUser);
                syncSelectedCompanyWithContacts(companySelect);


                formCreateUser.off('submit').on('submit', function (e) {

                    e.preventDefault();

                    $.ajax({
                        method: 'POST',
                        url: '/users/store',
                        data: $(this).serialize(),
                        success: function (response) {
                            tableUsers.DataTable().ajax.reload(null, false);
                            modalCreateUser.modal('hide');

                            printResponse(response);
                        },
                        error: function (data) {
                            listFormError(data, formCreateUser.find('.error-list'))
                        },
                    });

                });
                modalCreateUser.off('hidden.bs.modal').on('hidden.bs.modal', function () {
                    modalCreateUser.remove();
                });
            }
        });
    });
};

function syncSelectedCompanyWithRoles(companySelect, form) {
    var values = companySelect.val();
    var checkboxGroups = form.find('.ms-options li.optgroup');
    var allCheckboxes = checkboxGroups.find('input[type=checkbox]');
    var allOriginalOptions = form.find('#role_ids option');

    checkboxGroups.addClass('hidden');
    allCheckboxes.prop('checked', false);
    allCheckboxes.prop('disabled', true);
    allOriginalOptions.attr('checked', false);
    allOriginalOptions.attr('disabled', true);

    for(var i = 0; i < values?.length ?? 0; i++) {
        const companyToShow = companySelect.find('option[value="' + values[i] + '"]').text();

        for (var j = 0; j < checkboxGroups.length; j++) {
            const checkboxGroup = $(checkboxGroups[j]);
            const roleToShow = checkboxGroup.find('span.label').text();

            if (companyToShow == roleToShow) {
                checkboxGroup.removeClass('hidden');
                var currentCheckbox = checkboxGroup.find('li.selected').find('input[type=checkbox]');
                var originalOption = form.find('#role_ids option[value="' + currentCheckbox.val() + '"]');
                currentCheckbox.prop('disabled', false);
                currentCheckbox.prop('checked', true);

                originalOption.attr('checked', true);
                originalOption.attr('disabled', false);

                if (checkboxGroup.find('input[type=checkbox]:checked').length === 0) {
                    checkboxGroup.find('input[type=checkbox]').prop('disabled', false);
                }
            }
        };
    }

}

function syncSelectedCompanyWithContacts(companySelect) {
    let contactPersonSelect = $('select[name="contact_persons[]"]');
    let existingValues = contactPersonSelect.val();
    let options = [];

    companySelect.find('option:selected').each(function () {
        let selected = existingValues !== null && existingValues.indexOf($(this).val()) !== -1 ? 'selected' : '';
        options += '<option value="' + $(this).val() + '"' + selected + '>' + $(this).text() + '</option>'
    });
    contactPersonSelect.html(options);
    contactPersonSelect.select2({
        width: '100%', height: '100%'
    }).addClass('form-control');
    addFormControlSelect2();
}

function addChangeHandler(companySelect, form) {
    companySelect.on('change', function () {
        syncSelectedCompanyWithRoles(companySelect, form);
        syncSelectedCompanyWithContacts(companySelect);
    });
}

function addMultiSelectRoles(element, customLang, columns, selectAll) {
    var lang = allLangFiles.roles.select;

    element.multiselect({
        columns: columns,
        placeholder: customLang.placeholder,
        search: true,
        searchOptions: {
            'default': customLang.search_options.default
        },
        selectAll: selectAll,
        texts: {
            placeholder: lang.texts.placeholder,
            search: lang.texts.search,
            selectedOptions: lang.texts.selectedOptions,
            selectAll: lang.texts.selectAll,
            unselectAll: lang.texts.unselectAll,
            noneSelected: lang.texts.noneSelected,
        },
        onOptionClick: function (element, option) {
            var currentCheckboxGroup = $(option).parents('.optgroup').find('input[type="checkbox"]');
            var originalOptionsGroup = $(element).find('option[value="' + $(option).val() + '"]');
            if ($(option).parents('li').hasClass('selected')) {
                originalOptionsGroup.prop('disabled', false);
                currentCheckboxGroup.not($(option)).prop('disabled', true);
            } else {
                originalOptionsGroup.prop('disabled', true);
                currentCheckboxGroup.prop('disabled', false);
            }
        }
    });
}